﻿export function datesAreEqual(date1: Date, date2: Date): boolean { 
    return date1.getTime() === date2.getTime(); 
}

export function toDateOnly(date: Date): Date { 
    return new Date(date.getFullYear(), date.getMonth(), date.getDate()); 
}

export function addDays(date: Date, days: number): void {
    date.setDate(date.getDate() + days);
}

export function subtractDays(date: Date, days: number): void {
    date.setDate(date.getDate() - days);
}

export function formatDateString(dateTime: Date) {
    return dateTime.toLocaleTimeString("nl-NL", {
        weekday: 'short',
        day: 'numeric',
        month: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit'
    });
}

export function formatDateStringWithoutWeekday(dateTime: Date) {
    return dateTime.toLocaleTimeString("nl-NL", {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit'
    });
}

export function formatMomentTime(dateTime: Date) {
    return dateTime.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit', second: '2-digit' });
}

export function dateFromHHmm(time: string): Date {
    const [hours, minutes] = time.split(":").map(Number);

    return new Date(1970, 0, 1, hours, minutes, 0, 0);
}

export function toTimeOnly(dateTime: Date) {
    return new Date(1970, 0, 1, dateTime.getHours(), dateTime.getMinutes(), 0, 0);
}